export const actionTypes = {
  BRANCH_LIST: "BRANCH_LIST",
  ZONE_LIST: "ZONE_LIST",
  MEMBER_LIST: "MEMBER_LIST",
  REFUND_LIST: "REFUND_LIST",
  LOADER: "LOADER",
};

const INITIAL_STATE = {
  BranchList: [],
  ZoneList: [],
  MemberList: [],
  RefundList: [],
  teamloader: false,
};

const TeamReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.LOADER:
      return {
        ...state,
        teamloader: action.teamloader,
      };
    case actionTypes.BRANCH_LIST:
        return {
            ...state,
            BranchList: action.BranchList,
            teamloader: action.teamloader,
        };
    case actionTypes.ZONE_LIST:
        return {
            ...state,
            ZoneList: action.ZoneList,
            teamloader: action.teamloader,
        };
    case actionTypes.MEMBER_LIST:
        return {
            ...state,
            MemberList: action.MemberList,
            teamloader: action.teamloader,
        };
    case actionTypes.REFUND_LIST:
        return {
            ...state,
            RefundList: action.RefundList,
            teamloader: action.teamloader,
        };
    default:
      return state;
  }
};

export default TeamReducer;
